/**
 * <quantity-input> — progressively enhances a number input with − / + buttons.
 * Light-DOM (no shadow root, so theme CSS + the editor still work). The input
 * works without this script; this only wires the buttons. Self-guarded so it's
 * safe to load more than once.
 */
if (!customElements.get('quantity-input')) {
  customElements.define(
    'quantity-input',
    class QuantityInput extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.decBtn = this.querySelector('[data-quantity-decrease]');
        this.incBtn = this.querySelector('[data-quantity-increase]');
        if (!this.input) return;

        this.onDecrease = () => this.step(-1);
        this.onIncrease = () => this.step(1);
        if (this.decBtn) this.decBtn.addEventListener('click', this.onDecrease);
        if (this.incBtn) this.incBtn.addEventListener('click', this.onIncrease);
      }

      disconnectedCallback() {
        if (this.decBtn) this.decBtn.removeEventListener('click', this.onDecrease);
        if (this.incBtn) this.incBtn.removeEventListener('click', this.onIncrease);
      }

      step(direction) {
        const input = this.input;
        const stepValue = Number(input.step) || 1;
        const min = input.min !== '' ? Number(input.min) : -Infinity;
        const max = input.max !== '' ? Number(input.max) : Infinity;
        const current = Number(input.value) || 0;
        const next = Math.min(max, Math.max(min, current + direction * stepValue));

        if (next !== current) {
          input.value = String(next);
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  );
}
